module.exports = __webpack_public_path__ + "media/left-grey.bab29942.svg";